@import "../../../styles/global.scss";

.no-result {
  &__container {
    background-color: white;
    padding: 20px;
    margin: 20px 0px 40px 0px;

    @media (min-width: $tablet) {
      margin: 20px 20px 40px 0;

      &--conversational-widget {
        margin-bottom: 20px;
      }
    }

    &__title {
      font-weight: normal;
    }

    &__query {
      color: #333333;
    }

    &__message {
      margin-top: 32px;
      font-weight: normal;
    }
  }
}

.no-result-quotes {
  font-weight: 400;
  line-height: 22px;
  display: block;
  margin-top: 29px;
  margin-left: 32px;

  @media (min-width: $tablet) {
    &--conversational-widget {
      margin-bottom: 20px;
    }
  }
}

.no-results {
  @extend .no-result;
  &__container {
    margin: 40px 0;
  }
  &__title {
    font-size: 22px;
    line-height: 30px;
  }
  &__query {
    font-weight: 700;
  }
  &__message {
    line-height: 25px;
  }
  &__product-na-banner {
    margin-top: 40px;
  }
}
